import { ModalShowHide } from '../components/modal';

class SizePanel {
    #mobileSizeModal;
    #personalizeSizeModal;
    Types = {
        ADDTOCART: 'add_to_cart',
        ADDTOCART_BUNDLE: 'add_to_cart_bundle',
        PERSONALIZE: 'personalize',
        WISHILIST: 'wishlist',
        SMARTGIFT: 'smartgift'
    }

    init () {
        this.#onPanelOpenerClick();
        this.#onNotifyMeSizeClicked();
        this.#onCloseSizeModalMobile();
        this.#mobileSizeModal = new ModalShowHide('#size-panel-mobile');
        this.#personalizeSizeModal = new ModalShowHide('#size-panel-personalization');
        this.#mobileSizeModal.hide();
        this.onOutsideClick();
        this.allowButtonSwitch = true;
        this.#personalizeSizeModal.hide();
        this.sizePanelXbutton();
    }

    openSizePanel (operation) {
        this.triggerElement = document.activeElement;
        if (operation === this.Types.PERSONALIZE) {
            this.#personalizeSizeModal.show();
            setTimeout(() => {
                $('#size-panel-personalization .cc-size-pdp-container.js-container:visible').first().focus();
            }, 100);
        } else {
            if (Foundation.MediaQuery.atLeast('large')) {
                $('.js-page-size-box').addClass('cc-sizeBox-isOpen');
                setTimeout(() => {
                    $('.js-page-size-box .cc-size-pdp-container.js-container:visible').first().focus();
                }, 100);
            } else {
                this.#mobileSizeModal.show();
                setTimeout(() => {
                    $('#size-panel-mobile .cc-size-pdp-container.js-container:visible').first().focus();
                }, 100);
            }
        }
        $('#size-panel-mobile').data('operation', operation);
        if (operation === this.Types.ADDTOCART_BUNDLE) {
            let $sizeElements = $("[data-attr='size'] input,[data-attr='size-mobile'] input");
            let bundleQuantity = $('.js-add-to-cart-multipack').data('bundle-quantity');
            $sizeElements.each(function (element){
                if(parseInt($(this).attr('data-allocation'), 10) < parseInt(bundleQuantity, 10)) {
                    $(this).closest('label').addClass('cc-no-bundle');
                }
            })
        } else {
            $('.cc-no-bundle').removeClass('cc-no-bundle');
        }
        if(operation === this.Types.WISHILIST) {
            $('.notifyMe,.wishlistOnly').addClass('select-size-for-wishlist');
            $('.js-mobile-cart-label').addClass('hidden');
            $('.js-mobile-wishlist-label').addClass('hidden');
            $('.js-mobile-wishlist-select-label').removeClass('hidden');
            $('.cc-intProductDetail-size-quantity').addClass('hidden');
            $('.size-selectore').addClass('hide');

        } else {
            $('.notifyMe,.wishlistOnly').removeClass('select-size-for-wishlist');
            $('.js-mobile-cart-label').removeClass('hidden');
            $('.js-mobile-wishlist-label').addClass('hidden');
        }
    }

    #closeSizePanel () {        
        if (Foundation.MediaQuery.atLeast('large')) {
            $('.pdp-size-box').removeClass('cc-sizeBox-isOpen');
        } else {
            this.#mobileSizeModal.hide();
        }
        this.#personalizeSizeModal.hide();
        $('.pdp-size-box .js-sizeBox-openPanel').removeClass('cc-sizeBox-openPanel_error');
        $('#newsletter-error-msg').hide();
        $('#size-panel-mobile').data('operation', '');
        $('.notifyMe,.wishlistOnly').removeClass('select-size-for-wishlist');
        $('.cc-no-bundle').removeClass('cc-no-bundle');
        $('.js-mobile-cart-label').removeClass('hidden');
        $('.js-mobile-wishlist-label').addClass('hidden');
        $('.js-mobile-wishlist-select-label').addClass('hidden');
        $('.cc-intProductDetail-size-quantity').removeClass('hidden');
        $('.size-selectore').removeClass('hide');

        if (this.triggerElement) {
            $(this.triggerElement).focus();
            this.triggerElement = null;
        }
    }

    close () {
        this.#closeSizePanel();
    }

    onOutsideClick () {
        const _self = this;
        $('body').on('click', (e) => {
            var selectSizeBtn = $('.js-page-size-box').has(e.target).length || $('.js-page-size-box').is(e.target);
            var addToCartBtn = $('.js-addToCartWrapper').has(e.target).length || $('.js-addToCartWrapper').is(e.target) || $('.js-add-to-cart').has(e.target).length || $('.js-add-to-cart').is(e.target);
            var selectSizeBtnSticky = $('.js-pdpStickyBar-size-openPanel').has(e.target).length || $('.js-pdpStickyBar-size-openPanel').is(e.target);
            var sizePanel = $('.cc-sizeBox-panel').has(e.target).length || $('.cc-sizeBox-panel').is(e.target);
            var addToWishlistBtn = $('.add-to-wish-list').has(e.target).length || $('.add-to-wish-list').is(e.target);

            if ($('.cc-sizeBox-isOpen').length && !selectSizeBtn && !addToCartBtn && !selectSizeBtnSticky && !sizePanel && !addToWishlistBtn) {
                _self.#closeSizePanel();
                if ($('.js-pdpStickyBar-select.size-selected').length) {
                    this.switchButtonsSticky();
                }
                if ($('.js-sizeBox-openPanel.hidden').length) {
                    this.switchButtons();
                }
            }
        });
    }

    switchButtons () {
        if (this.allowButtonSwitch) {
            if ($('.js-sizeBox-openPanel').hasClass('hidden')) {
                $('.js-sizeBox-openPanel').removeClass('hidden');
                $('.js-addToCartWrapper').addClass('hidden');
            } else {
                $('.js-sizeBox-openPanel').addClass('hidden');
                $('.js-addToCartWrapper').removeClass('hidden');
            }
        }
    }

    switchButtonsSticky () {
        if (this.allowButtonSwitch) {
            if ($('.js-pdpStickyBar-select.size-selected').length) {
                $('.js-pdpStickyBar-select .js-add-to-cart.show-when-size-selected').removeClass('show-when-size-selected').addClass('hide-when-size-selected');
                $('.js-pdpStickyBar-select .js-pdpStickyBar-size-openPanel.hide-when-size-selected').removeClass('hide-when-size-selected').addClass('show-when-size-selected');
            }
        }
    }

    #onPanelOpenerClick () {
        $('.pdp-size-box .js-sizeBox-openPanel').on('click', e => {
            if ($('.pdp-size-box:not(.js-pdpStickyBar-select)').hasClass('cc-sizeBox-isOpen')) {
                this.#closeSizePanel();
            } else {
                if ($('[data-attr="size"] input:checked').length) {
                    this.switchButtons();
                }
                if ($('.js-pdpStickyBar-select.cc-sizeBox-isOpen').length) {
                    $('.js-pdpStickyBar-select.cc-sizeBox-isOpen').removeClass('cc-sizeBox-isOpen');
                }
                this.openSizePanel();
            } 
        });
        $('.js-pdpStickyBar-size-openPanel').on('click', e => {
            if ($('.js-pdpStickyBar-select').hasClass('cc-sizeBox-isOpen')) {
                $('.js-pdpStickyBar-select').removeClass('cc-sizeBox-isOpen');
            } else {
                if ($('.pdp-size-box.cc-sizeBox-isOpen').length) {
                    $('.pdp-size-box.cc-sizeBox-isOpen').removeClass('cc-sizeBox-isOpen');
                }
                $('.js-pdpStickyBar-select').addClass('cc-sizeBox-isOpen');
            }

            if ($('.js-pdpStickyBar-select.size-selected.cc-sizeBox-isOpen').length) {
                $('.js-pdpStickyBar-select .js-add-to-cart.hide-when-size-selected').removeClass('hide-when-size-selected').addClass('show-when-size-selected');
                $('.js-pdpStickyBar-select .js-pdpStickyBar-size-openPanel.show-when-size-selected').removeClass('show-when-size-selected').addClass('hide-when-size-selected');
            }
        });
    }

    afterSizeSelection (data, type) {
        let operation = $('#size-panel-mobile').data('operation');
        let stopSpinner = true;
        let selectedSize = $('[data-attr="size"] input:checked');
        if (!selectedSize.length) {
            $('.pdp-size-box').removeClass('size-selected');
            return stopSpinner;
        } else {
            $('#newsletter-error-msg').hide();
        }
        if (type !== 'size') {
            return stopSpinner;
        }

        if ($('.cc-intProductDetail-size-item_selected').length && $('.js-sizeBox-openPanel:not(.hidden)').length) {
            this.switchButtons();
        }
        
        let sizeDisplayValue = selectedSize.closest('label').find('.js-size-button__span').text();
        $('.pdp-size-box .js-sizeBox-openPanel').attr('aria-invalid', 'false');
        $('.pdp-size-box').addClass('size-selected');
        if ($('.js-add-to-cart-multipack').length > 0) {
            let bundleQuantity = $('.js-add-to-cart-multipack').data('bundle-quantity');
            if(parseInt($(selectedSize).attr('data-allocation'), 10) < parseInt(bundleQuantity, 10)) {
                $('.js-add-to-cart-multipack').attr('disabled', true);
            } else {
                $('.js-add-to-cart-multipack').removeAttr('disabled');
            }
        }

        stopSpinner = false;
        switch (operation) {
            case this.Types.ADDTOCART:
                $('#add-to-cart-cta-pdp').trigger('click');
                break;
            case this.Types.ADDTOCART_BUNDLE:
                $('#add-to-cart-multipack-cta-pdp').trigger('click');
                break;
            case this.Types.PERSONALIZE:
                $('#personalizeButton .persButt').trigger('click');
                break
            case this.Types.WISHILIST:
                $('body').trigger('wishlist:add-pid', {pid: data.product.id});
                break;
            case this.Types.SMARTGIFT:
                $('.add-to-cart-actions .js-smart-gift').trigger('click');
                $('#smartgiftButton').trigger('click');
                break;
            default:
                stopSpinner = true;
        }
        return stopSpinner;
    }

    #onNotifyMeSizeClicked () {
        const _self = this;
        $('.notifyMe,.wishlistOnly').on('click', (e) => {
            if (!$(e.currentTarget).hasClass('select-size-for-wishlist')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            const infoURL = $(e.currentTarget).closest('label').find('input').data('url');
            $.ajax({
                url: infoURL,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if (data.product.readyToOrder) {
                        if ($(e.currentTarget).hasClass('wishlistOnly')) {
                            let sizeDisplayValue = $(e.currentTarget).closest('label').find('.size-list-item-display-value').text();
                            $('.pdp-size-box').addClass('size-selected');
                        }
                        const pid = encodeURIComponent(data.product.id)
                        $('body').trigger('wishlist:add-pid', {pid: pid});
                    } else {
                        $.spinner().stop();
                        _self.#closeSizePanel();
                    }
                },
                error: function () {
                    $.spinner().stop();
                    _self.#closeSizePanel();
                }
            });
        });

        $('body').on('wishlist:update', () => {
            $.spinner().stop();
            _self.#closeSizePanel();
        });
    }

    #onCloseSizeModalMobile () {
        const _self = this;
        $('body').on('click', '.js-size-selector-mobile-modal', () => {
            _self.#closeSizePanel();

            if ($('.js-sizeBox-openPanel.hidden').length) {
                _self.switchButtons();
            }
        });
    }

    sizePanelXbutton () {
        const _self = this;
        $('body').on('click', '.js-close-size-panel', () => {
            _self.#closeSizePanel();
        });
    }
}

const sizePanel = new SizePanel();
export default sizePanel;
